/**
 * Contacts grid — filter the contact cards by the selected city tab.
 */
export function initContactsGrid() {
    document.querySelectorAll('.block-contacts-grid').forEach((root) => {
        const tabs = Array.from(root.querySelectorAll('.contacts-grid__tab'));
        const cards = Array.from(root.querySelectorAll('.contacts-grid__card'));

        if (!tabs.length || !cards.length) {
            return;
        }

        const select = (city) => {
            tabs.forEach((tab) => {
                const active = tab.dataset.city === city;
                tab.classList.toggle('bg-blue', active);
                tab.classList.toggle('text-white', active);
                tab.classList.toggle('text-black', !active);
                tab.setAttribute('aria-pressed', active ? 'true' : 'false');
            });

            cards.forEach((card) => {
                const cities = (card.dataset.cities || '').split(' ').filter(Boolean);
                card.hidden = !cities.includes(city);
            });
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => select(tab.dataset.city));
        });

        // Activate the first city on load to match the design.
        select(tabs[0].dataset.city);
    });
}
